<template>
  <v-dialog :value="filterForm.modalType === 'module'" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển module
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển loại hình"
              >
                <v-autocomplete
                  v-model="typeId"
                  :items="listType"
                  item-text="name"
                  item-value="id"
                  label="Chọn loại hình *"
                  :error-messages="errors"
                  @change="onChangeModule()"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="12">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  rules="required"
                  name="Chuyển nhóm nghành"
              >
                <v-autocomplete
                    v-model="schoolLevelId"
                    :items="listSchoolLevelByType"
                    item-text="name"
                    item-value="id"
                    label="Chọn nhóm ngành *"
                    :error-messages="errors"
                    @change="onChangeModule()"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="12">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  rules="required"
                  name="Chuyển kho"
              >
                <v-autocomplete
                    v-model="store"
                    :items="storeStocksForSelect"
                    item-text="name"
                    item-value="value"
                    label="Chọn kho *"
                    :error-messages="errors"
                    @change="onChangeModule()"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="12">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  name="Nhóm sản phẩm"
              >
                <v-autocomplete
                    v-model="productGroupId"
                    :items="productGroupsForSelect"
                    item-text="name"
                    item-value="id"
                    label="Nhóm sản phẩm (của module đã chọn)"
                    :error-messages="errors"
                    :disabled="!typeId || !schoolLevelId"
                />
              </validation-provider>
            </v-col>

            <v-col cols="12" md="12">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  rules=""
                  name="Người phụ trách"
              >
                <common-select-user
                    v-model="userId"
                    :items="users"
                    color="primary"
                    item-text="fullName"
                    item-value="id"
                    :error-messages="errors"
                    label="Người phụ trách"
                    :disabled="!typeId || !schoolLevelId"
                />
              </validation-provider>
            </v-col>

            <v-col cols="12" md="12">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  rules=""
                  name="Mối quan hệ"
              >
                <v-autocomplete
                    v-model="statusId"
                    :items="contactStatusList"
                    item-text="otherName"
                    item-value="id"
                    label="Mối quan hệ"
                    :error-messages="errors"
                    :disabled="!typeId || !schoolLevelId || !store"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="12">
                  <v-menu
                          ref="segmentMenu"
                          v-model="segmentMenu"
                          :close-on-content-click="false"
                          :return-value.sync="segmentCode"
                          transition="scale-transition"
                          offset-y
                          min-width="937px"
                          max-width="937px"

                  >
                      <template v-slot:activator="{ on, attrs  }">
                        <div v-on="on"
                             v-bind="attrs">
                        <validation-provider name="Tệp khách hàng">
                            <v-select
                                    :items="listSegment"
                                    item-value="id"
                                    item-text="segmentCode"
                                    hide-details
                                    persistent-hint
                                    readonly
                                    label="Tệp khách hàng"
                                    v-model="segmentId"
                                    chips
                                    class="select-segment"
                                    :menu-props="{ bottom: true, maxHeight: 250 }"
                            >
                                <template v-slot:selection="{ item }">
                                    <v-chip close
                                            text-color="#FFF"
                                            color="#FF6609"
                                            @click:close="handleDeleteSegment"
                                    >
                                        {{ item.segmentCode }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </validation-provider>
                        </div>
                      </template>
                          <div v-if="segmentId === ''" style="background: white; max-height: 400px; overflow: auto; padding: 0 12px 12px 12px">

                              <v-text-field
                                      dense
                                      ref="search"
                                      v-model="searchInput"
                                      full-width
                                      hide-details
                                      placeholder="Tìm kiêm tệp khách hàng"
                                      single-line
                              />
                               <div>
                                   <v-chip-group style="margin-top: 7px;" v-model="segmentId" column>
                                       <template v-for="segment in categoriesSegment">
                                           <v-chip  @click="segmentMenu = false" :value="segment.id" text-color="#FFF" color="#FF6609">{{ segment.segmentCode }}</v-chip>
                                       </template>
                                   </v-chip-group>
                               </div>
                              <p v-if="categoriesSegment.length == 0" style="padding-left: 5px;margin-top: 10px;font-size: 13px !important;color: #2F80ED !important; cursor: pointer" @click="handleCreateSegment"> <v-icon size="13" style="color: #2F80ED !important;">mdi-plus</v-icon> Thêm mới</p>
                          </div>
                  </v-menu>
              </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveChange)">Lưu lại</v-btn>
          <v-spacer />

          <v-btn color="primary" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import TokenService from "@/helpers/token";
const ContactRepository = RepositoryFactory.get('contact');
const TypeRepository = RepositoryFactory.get('type')
const ProductGroupRepository = RepositoryFactory.get('product_group');
const ContactStatusRepository = RepositoryFactory.get('contact_status');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    filterForm: {
      default: () => ({})
    },
    // contactStatusList: {
    //   type: Array,
    //   default: () => []
    // },
    contacts: {
      type: Array,
      default: () => []
    },
    // users: {
    //   type: Array,
    //   default: () => []
    // },
    schoolLevelList: {
      type: Array,
      default: () => []
    },
    storeStocks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      segmentCode: "",
      segmentMenu: false,
      segmentId: '',
      listSegment: [],
      showModal: false,
      errorMessage: '',
      store: '',
      typeId: '',
      schoolLevelId: '',
      listType: [],
      productGroups: [],
      productGroupsForSelect: [],
      productGroupId: '',
      contactStatusList: [],
      userId: '',
      statusId: '',
      storeStocksForSelect: [
        { value: 'T', name: 'Kho T' },
        { value: 'C', name: 'Kho C' },
        { value: 'M', name: 'Kho M' }
      ],
      users: [],
      searchInput: '',
      isSearch: false,
    };
  },
  created() {
    this.getListType();
    this.getProductGroups();
    this.getListSegmentCode()
    // this.getContactStatusList();
  },
  computed:{
    listSchoolLevelByType(){
      if(this.schoolLevelList.length > 0 && this.typeId){
          const result = this.schoolLevelList.find(school => school.id === this.typeId)
          return result.schoolLevel
      }else return []
    },
    categoriesSegment() {
        const search = this.searchInput
        const dataTemp = {  ...this.listSegment }
        if (!search) return  this.listSegment.length ?  this.listSegment.slice(0, 10) : []
       const dataListSearch = this.listSegment.filter(item => {
            const text = item.segmentCode
            return text.indexOf(search) > -1
        })
        return dataListSearch.length ? dataListSearch.slice(0, 10) : []
    }
  },

  methods: {
    handleDeleteSegment() {
      this.segmentId = '';
      this.segmentMenu = true;
    },
    async handleCreateSegment() {
        if(this.categoriesSegment.length == 0) {
            try {
                const params = {
                    "obj": "segments",
                    "data": {
                        "segmentCode": this.searchInput,
                        "createdBy": TokenService.getId(),
                        "updatedBy": TokenService.getId(),
                        "createdName":  TokenService.getFullName(),
                    }
                }
                const response = await TypeRepository.createSegmentApi(params)
                if(response.success) {
                    this.$swal({
                        title: 'Tạo tệp khách hàng thành công',
                        icon: 'success',
                    })
                    this.searchInput = ''
                    // this.isFirstTimeCreate = false;
                    this.segmentId =  response.data ? response.data?.id : '';
                    await this.getListSegmentCode()
                }else {
                    this.$swal({
                        title: 'Có lỗi xảy ra!',
                        icon: 'error',
                    })
                    this.listSegment = []
                }
            }catch (e) {
                console.log(e)
            }
        }
    },
    async getListSegmentCode() {
        try {
            const params = {
                'sorts[createdAt]':  'desc'
            }
            const response = await TypeRepository.listSegmentCodeApi(params)
            if(response.success) {
                this.listSegment = _.get(response, 'data', [])
            }else {
                this.listSegment = []
            }
        }catch (e) {
            console.log(e)
        }
    },
    hideModal: function() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.modalType = '';
      this.errorMessage = '';
      this.statusId = '';
    },
    async getListType() {
      const params = {
        limit: 1000
      }
      const response = await TypeRepository.list(params);
      if (response.success) {
        this.listType = _.get(response, 'data', [])
      }
    },
    async saveChange() {
      let changeContactList = this.contacts.filter(contact => contact.checkbox);

      const contactIds = changeContactList.map(contact => contact.id);
      const dataUpdate = {
        contactIds,
        store: this.store,
        schoolLevelId: this.schoolLevelId,
        typeId: this.typeId,
        productGroupId: this.productGroupId,
        userId: this.userId,
        statusId: this.statusId,
        segmentId: this.segmentId

      }
      this.loading = this.$loading.show();
      const response = await ContactRepository.changeModuleContactV3(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      }
      this.$swal({
        title: 'Chuyển module thành công!',
        confirmButtonText: 'Đồng ý'
      }).then(() => {
        this.hideModal();
        Bus.$emit('contact-list-filter', this.filterForm);
        // Bus.$emit('contact-status-list');
      });
    },
    async getProductGroups() {
      const respond = await ProductGroupRepository.list({
        limit: 1000,
        status: 'active'
      });
      if (_.get(respond, 'success', false)) {
        this.productGroups = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    onChangeModule() {
      if(this.typeId && this.schoolLevelId) {
        this.productGroupsForSelect = this.productGroups.filter(pG => pG.typeId == this.typeId && pG.schoolLevelId == this.schoolLevelId)
      }
      this.getContactStatusList()
    },
    async getContactStatusList() {

      if(!this.typeId || !this.schoolLevelId || !this.store) {
        return
      }

      const selectType = this.store === 'T' ? ['T0', 'T1', 'T2', 'T3']
          : this.store === 'C' ? ['C0', 'C1', 'C2', 'C3']
          : this.store === 'M' ? ['M0', 'M1', 'M2', 'M3', 'M4'] : [];
      const contactStatusList = [];
      // const loading = this.$loading.show();
      const response = await ContactStatusRepository.list({
        typeId: this.typeId,
        schoolLevelId: this.schoolLevelId,
        store: this.store,
      });
      // loading.hide();
      if (response.success) {
        const checkType = {};
        _.get(response, 'data', []).forEach(contactStatus => {
          const typeContactStatus = contactStatus.type;
          if (selectType.includes(typeContactStatus.slice(-2))) {
            if (!checkType[typeContactStatus]) {
              checkType[typeContactStatus] = true;
              if (contactStatusList.length > 0) {
                contactStatusList.push({divider: true});
              }
              contactStatusList.push({
                header: typeContactStatus.slice(0, typeContactStatus.length - 4),
                style: 'color: red;'
              });
              _.get(contactStatus, 'data', []).forEach(data => {
                data.otherName = `${typeContactStatus.slice(-2)} ${data.name}`
                contactStatusList.push({
                  id: _.get(data, 'id', 0),
                  otherName: _.get(data, 'otherName', ''),
                  type: _.get(data, 'type', '')
                });
              });
            }
          }
        });
      }
      this.contactStatusList = contactStatusList;
    },
    async getListUserForSelect() {
      // Danh sách user theo bộ phận cấp 3
      const res = await OrganizationMachineRepository.listUserContactAdviseByLevel({
        schoolLevelId: this.schoolLevelId,
        typeId: this.typeId,
        level: 3
      })

      if (res.success) {
        let listUsers = _.get(res, 'data', [])
        const groupUsers = [];
        listUsers.forEach(ministry => {
          const { users = [] } = ministry;
          if (users.length) {
            groupUsers.push({
              header: ministry.name,
              name: _.get(ministry, 'name'),
              ministryId: ministry.id,
            });
            users.forEach(user => {
              groupUsers.push({
                fullName: _.get(user, 'fullName'),
                group: _.get(ministry, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.users = groupUsers;
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    }
  },
  watch: {
      searchInput: {
          deep: true,
          handler(newVal) {
              if(newVal) {
               this.isSearch= true
              }
          }
      },
      segmentId: {
          deep: true,
          handler(newVal) {
              this.searchInput = ''
          }
      },
    schoolLevelId: {
      deep: true,
      handler(newVal) {
        this.getListUserForSelect()
      }
    },
    typeId: {
      deep: true,
      handler(newVal) {
        this.schoolLevelId = null
        this.getListUserForSelect()
      }
    }
  }
};
</script>

<style lang="scss">
///deep/ .v-subheader.theme--light {
//  font-size: 10px;
//  font-weight: bold;
//}
</style>
